module.exports = __webpack_public_path__ + "static/keyboard-89256a54d54dfcf18cf87a3905734a22.svg";